import APIDriver from './api/APIDriver';

const api = new APIDriver('version_cities');

const service = {
    listByVersion: (id) => {
        api.setBearerProtection();
        return api.get('version', id);
    },
    listByCity: (id) => {
        api.setBearerProtection();
        return api.get('city', id);
    },
    listByVersionAndCity: (version_id, city_id) => {
        api.setBearerProtection();
        return api.get('version-city',
            [
                version_id,
                city_id
            ]
        );
    },
    get: (id) => {
        api.setBearerProtection();
        return api.get('', id);
    },
    list: () => {
        api.setBearerProtection();
        return api.getAll('');
    },
    create: (data) => {
        api.setBearerProtection();
        return api.post('', data);
    },
    update: (id, data) => {
        api.setBearerProtection();
        return api.patch('', id, data);
    },
    remove: (id) => {
        api.setBearerProtection();
        return api.delete('', id);
    }
}

export default service;